import { jsx as h } from "react/jsx-runtime";
import { forwardRef as w } from "react";
const f = w(
  ({
    size: t,
    height: n,
    width: r,
    fill: e,
    strokeWidth: o,
    stroke: i,
    className: a,
    children: c,
    viewBox: k,
    ...d
  }, L) => /* @__PURE__ */ h(
    "svg",
    {
      className: a,
      width: t && r ? r : t || "24",
      height: t && n ? n : t || "24",
      viewBox: k || "0 0 24 24",
      fill: e || "none",
      stroke: i || "currentColor",
      strokeWidth: o || "2",
      xmlns: "http://www.w3.org/2000/svg",
      ref: L,
      ...d,
      children: c
    }
  )
), j = w(
  (t, n) => /* @__PURE__ */ h(
    "path",
    {
      ...t,
      stroke: t.stroke ? t.stroke : "inherit",
      strokeWidth: t.width ? t.width : "inherit",
      strokeLinecap: t.strokeLinecap ? t.strokeLinecap : "round",
      strokeLinejoin: t.strokeLinejoin ? t.strokeLinejoin : "round",
      ref: n
    }
  )
);
export {
  j as Path,
  f as SVG
};
